import { useForm } from "react-hook-form";
import { useState } from "react";

async function sendEmailToServer(data: any) {
  const email = {
    subject: data.subject,
    message: data.message,
    sender: data.sender_email,
    sender_wants_copy: true,
  };
  return await fetch("https://playguru.app:8000/email/no-session", {
    method: "POST",
    body: JSON.stringify(email),
    headers: {
      "Content-Type": "application/json",
    },
  });
}

interface AvatarProps {
  name: string;
  url: string;
}

function Avatar({ name, url }: AvatarProps) {
  return (
    <div className="flex flex-col justify-start items-center rounded-3xl p-5">
      <img
        className="object-cover w-20 h-20  md:w-40 md:h-40 rounded-full shadow-2xl"
        src={url}
        alt="avatar"
      />
      <div className="pt-4 text-primary text-xl font-bold">{name}</div>
    </div>
  );
}

function Contact() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [showThankYou, setShowThankYou] = useState(false);

  const onSubmit = (data: any) => {
    sendEmailToServer(data).then((r) => {
      setShowThankYou(true);
      console.log(r);
    });
  };

  return (
    <div id="contact" className="bg-primary w-full">
      <h1 className="text-on_primary text-6xl md:text-8xl text-center p-10">
        Contact us
      </h1>
      <div className="w-full text-white flex lg:flex-row flex-col lg:items-start items-center justify-center ">
        <div className="basis-[100%] flex flex-col max-w-prose lg:text-start text-center p-10 m-5 mr-5 bg-background shadow-2xl rounded-3xl">
          <div className="flex flex-row justify-evenly">
            <Avatar
              name={"Wouter"}
              url={
                "https://dinkum.nl/developer_pictures_Acoa7kaitoo5eeKo/wouter.png"
              }
            />
            <Avatar
              name={"Marc"}
              url={
                "https://dinkum.nl/developer_pictures_Acoa7kaitoo5eeKo/marc.png"
              }
            />
          </div>

          <p className="max-w-prose pt-5 text-xl text-center">
            PlayGuru is created by
            <br /> Marc Groenewegen and Wouter Ensink.
            <br />
            <br />
            We would love to hear about your experiences: what you like about
            PlayGuru, what can be improved or features you are missing.
            <br />
            <br />
            Please send us your feedback from within the app,
            <br />
            or contact us using the form below.
          </p>
        </div>

        {showThankYou && (
          <div className="basis-[100%] w-max shadow-2xl min-h-[500px] m-5 p-5 flex flex-col items-center justify-center text-primary bg-background rounded-3xl">
            <h1 className="text-5xl text-center">Thank You!</h1>
            <p className="text-xl p-5">
              We'll get back to you as soon as possible.
            </p>
          </div>
        )}
        {!showThankYou && (
          <form
            className="basis-[100%] w-full m-5 p-5 flex flex-col max-w-prose text-primary bg-background rounded-3xl shadow-2xl"
            onSubmit={handleSubmit(onSubmit)}
          >
            <p>Your email address</p>
            <input
              placeholder={"example@email.com"}
              className="bg-primary text-xl p-2 mt-2 text-on_primary rounded-xl"
              {...register("sender_email", { required: true })}
            />
            {errors.sender_email && (
              <span className="text-red">This field is required</span>
            )}
            <p className="mt-4">Subject</p>
            <input
              placeholder={"What's your message about?"}
              className="text-xl bg-primary p-2 mt-2 text-on_primary rounded-xl"
              {...register("subject", { required: true })}
            />
            {errors.subject && (
              <span className="text-red">This field is required</span>
            )}
            <p className="mt-4">Message</p>
            <textarea
              placeholder={"Type your message here..."}
              rows={8}
              className="text-xl p-2 mt-2 bg-primary text-on_primary rounded-xl "
              {...register("message", { required: true })}
            />
            {errors.body && (
              <span className="text-red">This field is required</span>
            )}
            <input
              className="bg-secondary p-2 mt-8 mb-4 rounded-xl text-2xl"
              type="submit"
            />
          </form>
        )}
      </div>
    </div>
  );
}

export default Contact;
